import { Input, Label, Tooltip } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './PhoneNumberField.module.css';
import { TPersonalDetailsDataDE } from '../../PersonalDetailsDE';

const PhoneNumberField = () => {
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TPersonalDetailsDataDE>();

  return (
    <div>
      <div className={styles.formLabel}>
        <Label htmlFor="phoneNumber">
          <Trans>Main phone number</Trans>
        </Label>
        <Tooltip
          content={t`We’ll use your phone number to contact you about your application.`}
        />
      </div>
      <Input
        {...register('phoneNumber')}
        id="phoneNumber"
        type="text"
        placeholder={t`e.g. 07700 900000`}
        error={errors?.phoneNumber?.message}
        className="fs-mask"
      />
    </div>
  );
};

export default PhoneNumberField;
